import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const DEVICE_DIMENSIONS_PROCEED_CTA = {
    DESKTOP_MIN: "1024px",
    TABLET_MAX: "1023px",
};

export const ContentContainer = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].canvas_Primary,
    padding: `${theme.spacing.xLarge} ${theme.spacing.medium}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxLarge,
    marginBottom: `calc(${theme.spacing.xLarge} * 6)`,
}));

export const ProceedCtaWrapper = styled.div<{ showTurboPayment?: boolean; showAlertBanner?: boolean }>(
    ({ theme, showTurboPayment, showAlertBanner }) => ({
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: theme.spacing.medium,
        paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
        background: theme.colors[theme.colorMode].background_Primary,
        boxShadow: theme.elevation[theme.colorMode].liftedNegative.boxShadow,
        zIndex: 2,
        borderRadius: `${theme.cornerRadius.large} ${theme.cornerRadius.large} 0 0`,
        [`@media (min-width: ${DEVICE_DIMENSIONS_PROCEED_CTA.TABLET_MAX})`]: {
            maxWidth: "700px",
            margin: "0 auto",
            left: "50%",
            transform: "translateX(-50%)",
        },
        "@supports (padding-bottom: var(--sab))": {
            paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
        },
        ...(showTurboPayment && {
            padding: 0,
        }),
        ...(showAlertBanner && {
            borderRadius: `${theme.cornerRadius.small} ${theme.cornerRadius.small} 0 0`,
        }),
    }),
);

export const CTASubText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
    marginTop: `calc(${theme.spacing.xxxSmall} * -1)`,
    marginBottom: theme.spacing.xSmall,
    width: "100%",
    textAlign: "center",
}));

export const SwiggyOneWidgetWrapper = styled.div({
    // this change is required to remove the margin that is present in the child div
    "& > div": {
        margin: "0",
    },
});

export const ListTextWrapper = styled(Text)(({ theme }) => ({
    "& > ul": {
        padding: `0 ${theme.spacing.medium}`,
        paddingBottom: 0,
        listStyleType: "disc",
    },
    "& > ol": {
        padding: `0 ${theme.spacing.medium}`,
        paddingBottom: 0,
        listStyleType: "decimal",
    },
}));

export const TicketDetailsWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.small,
}));

export const SavingWidgetWrapper = styled.div(({ theme }) => ({
    marginBottom: `calc(-1 * ${theme.spacing.xSmall})`,
}));

/** Groups partial payment radio + conditional DineCash nudge so spacing stays tight. */
export const PartialPaymentSection = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    width: "100%",
}));

export const DividerWrapper = styled.div(({ theme }) => ({
    width: "100vw",
    height: theme.spacing.xSmall,
    margin: `0px calc(-1 * ${theme.spacing.medium})`,
    backgroundColor: theme.colors[theme.colorMode].border_Tertiary,
    marginBottom: `calc(-1 * ${theme.spacing.small})`,
}));

export const ListViewWithBorder = styled.div(({ theme }) => ({
    "& > div > div:last-child": {
        borderBottom: `${theme.spacing.xxxSmall} solid ${theme.colors[theme.colorMode].border_Tertiary}`,
    },
}));
